<template>
  <div class="row align-items-start">
    <div class="card-group col-lg-4 col-md-6 col-sm-12" v-for="(post, index) in posts" :key="index">
      <div v-if="index == 2 || index == 6" class="card">
        <div v-if="index == 2" class="banner-promotion">
          <a :href="bannerArroba2.url">
            <img :src="bannerArroba2.image" :alt="bannerArroba2.url" width="394" height="333"/>
          </a>
        </div>
        <div v-else="index == 6" class="banner-promotion">
          <a :href="bannerArroba6.url">
            <img :src="bannerArroba6.image" :alt="bannerArroba6.url" width="394" height="333"/>
          </a>
        </div>
      </div>
      <div v-else class="card">
        <router-link
          :to="{
            name: 'ColumnSingle',
            params: { 
              locale: this.locale,
              catergoriaId: post.tag_id,
              categoriaName: post.slugCategory,
              colunaId: post.id,
              colunaName: post.slug
            }
          }"
        >
          <img :src="`${post.cover}`" :alt="post.title" width="394" height="333"/>
        </router-link>        
        <div class="card-body pb-5">
          <p
            class="card-text"
            v-for="description in post.meta_description"
            :key="description.language_id"
          >
            <span
              class="category-title py-1 px-3 mt-1"
              v-if="description.language_id === 1 && locale === 'pt-br'"
              v-text="post.category"
            ></span>
            <span
              class="category-title py-1 px-3 mt-1"
              v-if="description.language_id === 2 && locale === 'en'"
              v-text="post.category"
            ></span>
          </p>
          <router-link
            :to="{
              name: 'ColumnSingle',
              params: { 
                locale: this.locale,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
                colunaId: post.id,
                colunaName: post.slug
              }
            }"
          >
            <h5 class="card-title">{{ post.title }}</h5>
          </router-link>                  
          <p
            class="card-text row"
            v-for="description in post.meta_description"
            :key="description.language_id"
          >
            <span
              v-if="description.language_id === 1 && locale === 'pt-br'"
              v-text="description.content"
            ></span>
            <span
              v-if="description.language_id === 2 && locale === 'en'"
              v-text="description.content"
            ></span>
          </p>

          <router-link
            :to="{
              name: 'ColumnSingle',
              params: { 
                locale: this.locale,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
                colunaId: post.id,
                colunaName: post.slug
              }
            }"
            class="button--more"
          >
            {{ translateMain.moreBlog }}
            <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm" style="margin-left: 8px" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateMain from 'tradutors/menu'
  import api from '../../api'
  export default {
    name: 'PostListItem',
    props: ['posts'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateMain: function () {
        this.getBannerArroba(2)
        this.getBannerArroba(6)
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      },
    },
    data() {
      return {
        bannerArroba2: {image:'', url:''},
        bannerArroba6: {image:'', url:''},
      }
    },
    methods: {
      async getBannerArroba(local) {
        await api.get(`v1/home/getBannerArroba?language=${this.locale ?? ''}`).then(({ data }) => {
          if (local == 2) {
            this.bannerArroba2 = data.bannerArroba
          } else {
            this.bannerArroba6 = data.bannerArroba
          }
        })
      },

    }
  }
</script>
<style scoped>
  .card-title {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;
  }

  .card-text {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    margin-bottom: 8px;
  }

  .button--more svg {
    color: #b20000;
  }

  .button--more {
    height: 19px;
    color: #666666;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .small svg {
    margin-right: 5px;
  }

  .card img {
    width: 100%;
    height: 333px;
    object-fit: cover;
  }

  .banner-promotion img {
    width: 100%;
    height: 333px;
    cursor: pointer;
    object-fit: cover;
  }

  .card-body {
    background-color: #fff;
    padding: 16px 0px;
  }

  .category-title {
    background-color: black;
    border-radius: 20px;
    text-align: center;
    max-width: 9rem;
    color: #fff;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
  }
</style>
